<template>
  <div>
    <a-card
      class="mt-20"
      :bordered="false"
    >
      <!-- 表格筛选 start -->
      <a-form layout="inline">
        <a-form-item class="mr-20">
          <a-input
            v-model="queryParam.keyWord"
            placeholder="搜索关键字"
            allowClear
          >
            <a-select
              slot="addonBefore"
              v-model="queryParam.searchType"
              placeholder="搜索类型"
              style="width: 120px"
            >
              <a-select-option
                :value="item.id"
                :key="item.id"
                v-for="item in dict.searchTypeDict"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-input>
        </a-form-item>
        <a-form-item class="mr-20">
          <a-select
            v-model="queryParam.level"
            allowClear
            placeholder="分类级别"
            style="width: 220px"
          >
            <a-select-option :value="1">一级分类</a-select-option>
            <a-select-option :value="2">二级分类</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button
            class="mr-10"
            type="primary"
            @click="handleFilter"
          >
            搜索
          </a-button>
          <a-button @click="handleReset">
            重置
          </a-button>
        </a-form-item>
      </a-form>
      <!-- 表格筛选 end -->
      <!-- 表格内容操作 start -->
      <div class="mt-20">
        <a-button
          type="primary"
          class="mr-20"
          @click="handleAdd"
        >新增分类</a-button>
      </div>
      <!-- 表格内容操作 end -->
      <!-- 表格 start -->
      <tcg-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        bordered
        class="mt-20"
      >
        <span
          slot="picture"
          slot-scope="text"
          v-if="text"
        >
          <img
            :src="text"
            @click="handlePreviewPic(text)"
            style="width:64px;height:64px"
          />
        </span>
        <span
          slot="action"
          slot-scope="text, record"
        >
          <template>
            <a-button
              type="link"
              @click="handleEdit(record.category_id)"
            >编辑</a-button>
          </template>
          <template>
            <a-button
              type="link"
              @click="handleDelete(record.category_id)"
            >删除</a-button>
          </template>
        </span>
      </tcg-table>
      <!-- 表格 end -->
    </a-card>
    <!-- 查看大图 -->
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible = false"
      :width="500"
    >
      <img
        alt="example"
        style="width:100%; margin-top:30px"
        :src="previewImage"
      />
    </a-modal>
    <!-- 新增分类 -->
    <goods-type-modal
      ref="goodsTypeModal"
      @ok="handleFilter"
    />
  </div>
</template>

<script>
import { TcgTable } from '@/components'
import GoodsTypeModal from './components/GoodsTypeModal'
import { getGoodsCategoryList, postGoodsCategoryDel } from '@/api/goods'

const defaultQueryParam = {
  searchType: 'name'
  // keyWord: '',
  // level: null
}

export default {
  name: 'GoodsTypeList',
  components: { TcgTable, GoodsTypeModal },
  data() {
    return {
      queryParam: Object.assign({}, defaultQueryParam),
      // 字典
      dict: {
        searchTypeDict: [
          { id: 'name', name: '名称' },
          { id: 'brand_id', name: '品牌ID' }
        ]
      },
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getGoodsCategoryList(Object.assign(parameter, this.queryParam)).then((res) => {
          return res
        })
      },
      columns: [
        {
          title: '分类名称',
          dataIndex: 'name'
        },
        {
          title: '品牌ID',
          dataIndex: 'brand_id'
        },
        {
          title: '所属品牌',
          dataIndex: 'brand_name'
        },
        {
          title: '分类图片',
          dataIndex: 'picture',
          width: '100px',
          scopedSlots: { customRender: 'picture' }
        },
        {
          title: '级别',
          dataIndex: 'level',
          width: '100px'
        },
        {
          title: '上级分类',
          dataIndex: 'parent_name'
        },
        {
          title: '排序',
          dataIndex: 'sort',
          width: '80px'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'id',
          width: '150px',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 预览图片
      previewVisible: false,
      previewImage: ''
    }
  },
  created() {
    if (this.$route.query.brand_id) {
      this.queryParam.keyWord = this.$route.query.brand_id
      this.queryParam.searchType = 'brand_id'
      this.$nextTick(() => {
        this.$refs.table.refresh(true)
      })
    }
  },
  methods: {
    handleFilter() {
      this.$refs.table.refresh(true)
    },
    handleReset() {
      this.queryParam = Object.assign({}, defaultQueryParam)
      this.$refs.table.refresh(true)
    },
    // 新增
    handleAdd() {
      this.$refs.goodsTypeModal.showModal()
    },
    // 编辑
    handleEdit(id) {
      this.$refs.goodsTypeModal.showModal(id)
    },
    // 删除
    handleDelete(id) {
      this.$confirm({
        title: '确定要删除?',
        onOk: () => {
          postGoodsCategoryDel({
            category_id: id
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('删除成功')
                this.$refs.table.refresh(true)
              }
            })
            .catch((e) => {
              this.$message.error('删除失败')
            })
        }
      })
    },
    // 预览图片
    handlePreviewPic(pic) {
      this.previewImage = pic
      this.previewVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
</style>
